import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioAltaVoluntariaService {

  constructor( private requestUrl: ReportesRequestService ) { }

  public async getFiltroAltaVoluntaria( codigoBaseDatos: string, uncoAdmision: string, uncoEmpresa: string ) {
    try {
      const response = await this.requestUrl.getFilterRequest(
        'alta-voluntaria/data',
        [
          codigoBaseDatos,
          {
            'ln_unco_admsns': uncoAdmision,
            'ln_unco_empresa': uncoEmpresa
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;

  }

  public async getFiltroEmpresasAltaVoluntaria( codigoBaseDatos: string, uncoAdmision: string ) {

    try {
      const response = await this.requestUrl.getFilterRequest(
        'alta-voluntaria/data-empresas',
        [
          codigoBaseDatos,
          {
            'ln_unco_admsns': uncoAdmision
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;

  }

  public async getDataAltaVoluntaria( param: ObjectRequest ) {

    try {
      const response = await this.requestUrl.getRequest(
        'admision/alta-voluntaria',
        [
          param.codigoBaseDatos,
          {
            'ln_unco_admsns': param.uncoAdmision,
            'ln_unco_empresa': param.uncoEmpresa,
            'ln_unco_mtvo_acta_vlntra': param.uncoMotivoAlta
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;

  }

}

export interface ObjectRequest {
  codigoBaseDatos: string;
  uncoAdmision: string;
  uncoEmpresa: string;
  uncoMotivoAlta: string;
}

export interface AltaVoluntariaEntity {

  consecutivoAdmision: string;
  numeroIdentificacion: string;
  tipoDocumento: string;
  sexo: string;
  sede: string;
  paciente: string;
  puntoAtencion: string;
  direccion: string;
  telefono: string;
  fechaAdmision: string;
  descripcionCorta: string;
  motivoAltaVoluntaria: string;

}
